<template>
  <div class="container">
    <div class="d-flex justify-content-between">
      <span class="text-light">{{powered}}</span>
      <span class="version text-light">
        <i class="fa fa-code-branch text-success" aria-hidden="true"></i>
        {{version}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      powered: "powered by ZonaApp",
      version: "1.7.0"
    };
  }
};
</script>

<style lang="scss">
/* media queries */

@media screen and (min-width: 768px) {
  .app-footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    line-height: 60px;
    font-size: 80%;
  }
}
</style>
